import React, { useEffect, useState } from "react"
import { ListView } from "../factory/ViewUtil"
import AssetsHeaderView from "./AssetsHeaderView"
import { AssetsListener, AssetsListenerRemove, RefreshAssets } from "./AssetsManager"
import { isLogin } from "../../NetworkFactory"
import { CellAssetsView, CellStateView } from "../factory/CellViews"
import { DecimalComparedToZero } from "../factory/FactoryUtil"

const AssetsFragmentController = (props) => {

    const type = props.type || '1'
    const [data, setData] = useState([]);
    const [assetsData, setAssetsData] = useState([]);
    const [assetsTotal, setAssetsTotal] = useState('0.00');
    const [stateCode, setStateCode] = useState(isLogin() ? 3 : 2);
    const [selected, setSelected] = useState(true);
    const [refreshRequest, setRefreshRequest] = useState(false);

    const openAccount = (item)=> {
        props.loginpush('/assets/account', false, {data : item, type : type})
    }
    
    // # 显示方式改变
    const changeType = (val) => {
        setSelected(val)
    }

    // # 显示数据
    const displayData = (data = []) => {
        let count = 0
        if(selected) {
            count = data.length
            setAssetsData(data)
        } else {
            let newData = []
            data.forEach(item => {
                if(DecimalComparedToZero(item.equivalent) > 0) {
                    newData.push(item)
                }
            })
            count = newData.length
            setAssetsData(newData)
        }
        setStateCode(count >0 ? -1 : 1)
    }

    // # 刷新资产
    const refreshAssets = () => {
        setStateCode(3)
        RefreshAssets(type)
    }

    useEffect(() => {
        if(refreshRequest) {
            displayData(data)
        }
    }, [selected, data, refreshRequest]) // eslint-disable-line react-hooks/exhaustive-deps

    // # 初始化
    useEffect(() => {
        if(isLogin()) {
            AssetsListener(type, 'AssetsViewController', response => {
                let tempData = response.data || []
                setData([...tempData])
                setAssetsTotal(response.total)
                setRefreshRequest(true)
            })
            return () => {
                AssetsListenerRemove(type, 'AssetsViewController')
            }
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    
    return (
        <div style={{padding : '0 18px'}}>
            <ListView>
                <AssetsHeaderView initSelected={selected} changeType={(val)=>{changeType(val)}} balance={assetsTotal} type={type} {...props}/>
                <CellStateView stateType={stateCode} onRefresh={refreshAssets} goLogin={()=>{props.navpush('/login')}}/>
                {
                    assetsData.map((item, index) => (
                        <CellAssetsView onClick={()=>{openAccount(item)}} key={index} item={item}/>
                    ))
                }
            </ListView>
        </div>
    )
}

export default React.memo(AssetsFragmentController)